import { UniversalUpgradeProduct } from '@airship-platform/airship-proposal';

export interface PricebookUniversalUpgradeProductsState {
  ids: string[];
  entities: Record<string, UniversalUpgradeProduct>;
  currentPricebookUniversalUpdradeProductId: string | null;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
}

type Action =
  | { type: 'FETCH_PRICEBOOK_UNIVERSAL_UPGRADE_PRODUCTS' }
  | {
      type: 'FETCH_PRICEBOOK_UNIVERSAL_UPGRADE_PRODUCTS_SUCCESS';
      payload: { pricebookUniversalUpgradeProducts: UniversalUpgradeProduct[] };
    }
  | {
      type: 'FETCH_PRICEBOOK_UNIVERSAL_UPGRADE_PRODUCTS_FAILURE';
      payload: { error: string };
    }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initState: PricebookUniversalUpgradeProductsState = {
  ids: [],
  entities: {},
  currentPricebookUniversalUpdradeProductId: null,
  isLoading: false,
  isLoaded: false,
  error: null,
};

export const pricebookUniversalUpgradeProductsReducer = (
  state: PricebookUniversalUpgradeProductsState,
  action: Action
): PricebookUniversalUpgradeProductsState => {
  switch (action.type) {
    case 'FETCH_PRICEBOOK_UNIVERSAL_UPGRADE_PRODUCTS':
      return {
        ...state,
        isLoading: true,
        isLoaded: !!state.ids.length,
        error: null,
      };
    case 'FETCH_PRICEBOOK_UNIVERSAL_UPGRADE_PRODUCTS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [
          ...new Set([
            ...state.ids,
            ...action.payload.pricebookUniversalUpgradeProducts.map(
              (i) => i.pricebookUniversalUpgradeId
            ),
          ]),
        ],
        entities: action.payload.pricebookUniversalUpgradeProducts.reduce(
          (prev, curr) => ({
            ...prev,
            [curr.pricebookUniversalUpgradeId]: curr,
          }),
          state.entities
        ),
      };
    case 'FETCH_PRICEBOOK_UNIVERSAL_UPGRADE_PRODUCTS_FAILURE':
      return { ...state, isLoading: false, error: action.payload.error };
    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
